import EditIcon from '../../../utils/media/icons/edit_icon.png';
import ViewIcon from '../../../utils/media/icons/view_icon.png';
import DeleteIcon from '../../../utils/media/icons/delete_icon.png';
import { useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';

const TableList = ({ data }) => {

    const [selectedRows, setSelectedRows] = useState(new Set());

    const toggleSelectAll = () => {
        if (selectedRows.size === data.length) {
            setSelectedRows(new Set());
        } else {
            setSelectedRows(new Set(data.map(user => user._id)));
        }
    };

    const toggleSelectRow = (id) => {
        const newSelected = new Set(selectedRows);
        if (newSelected.has(id)) {
            newSelected.delete(id);
        } else {
            newSelected.add(id);
        }
        setSelectedRows(newSelected);
    };

    const renderSize = (size) => {
        if (size < 1024) return `${size} Bytes`;
        else if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        else return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };
    
    const renderTime = (time) => {
        const splitTime = time.split(':');
        if(splitTime[0] >= 12) return splitTime[0]-12 +':'+ splitTime[1] + ' pm';
        else return splitTime[0] +':'+ splitTime[1] + ' am';
    }
    
    const handleDelete = (key) => {
        console.log(key);
        const conf = window.confirm('Are you sure you want to delete the selected items?');
        if (conf) {
            // deleteSingleMedia(key, toast);
        }
    }
    
    return (
        <div className="overflow-x-auto mt-6">
            <table className="w-full border-collapse overflow-x-scroll text-sm" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        <th className="p-3 text-left">
                            <input
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-300 accent-primary"
                                checked={selectedRows.size === data.length}
                                onChange={toggleSelectAll}
                                aria-label="Select all data"
                            />
                        </th>
                        <th className="p-3 text-left">Srl. No.</th>
                        <th className="p-3 text-left">Image</th>
                        <th className="p-3 text-left">Name</th>
                        <th className="p-3 text-left">Input Type</th>
                        <th className="p-3 text-left">Size</th>
                        <th className="p-3 text-center">Created On</th>
                        <th className="p-3 text-left">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, id) => (
                        <tr
                            key={item._id}
                            className="border-b border-navBtn hover:bg-gray-50"
                        >
                            <td className="p-3">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300 accent-primary mt-1"
                                    checked={selectedRows.has(item._id)}
                                    onChange={() => toggleSelectRow(item._id)}
                                    aria-label={`Select ${item.name}`}
                                />
                            </td>
                            <td className="p-3">{++id}</td>
                            <td className="p-3">
                                <img src={item.url} alt="item url" className='h-8 w-8 object-cover' />
                            </td>
                            <td className="p-3">{item.key.length > 50 ? item.key.slice(0, 50) : item.key}</td>
                            <td className="p-3 capitalize">{item.inputType || 'image'}</td>
                            <td className="p-3 min-w-24">{renderSize(item.size)}</td>
                            <td className="p-3 min-w-40 place-items-center">{new Date(item.lastModified).toDateString() + ' ' + renderTime(new Date(item.lastModified).toLocaleTimeString())}</td>
                            <td className="p-3 min-w-32">
                                <button className="rounded p-1.5 bg-[rgba(0,122,155,0.1)] hover:bg-[rgba(0,122,155,0.2)] min-h-7 mr-1" 
                                    // onClick={() => navigate('/challenges/edit/category', { state: { _id: item._id }})}
                                >
                                    <img src={EditIcon} alt="edit" />
                                </button>
                                <button className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7" onClick={() => window.open(item.url, '_blank')}>
                                    <img src={ViewIcon} alt="view" />
                                </button>
                                <button className="rounded p-1.5 bg-[rgba(250,22,22,0.1)] hover:bg-[rgba(250,22,22,0.2)] min-h-7 ml-1 px-2" onClick={() => handleDelete(item.key)}>
                                    <img src={DeleteIcon} alt="delete" />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TableList;